import { getApis } from '../../library/Apis';
import { toRequest } from '../../utils/RequestUtils';

export const RESETED_ASSESSORES = 'RESETED_ASSESSORES';
export const CHANGE_ASSESSOR_STATUS_ACTION = 'CHANGE_ASSESSOR_STATUS_ACTION';
export const SAVED_ASSESSOR_ACTION = 'SAVED_ASSESSOR_ACTION';
export const LOADED_ASSESSOR_ACTION = 'LOADED_ASSESSOR_ACTION';
export const LOADING_ASSESSORES_ACTION = 'LOADING_ASSESSORES_ACTION';
export const CLEARED_ASSESSORES_ACTION = 'CLEARED_ASSESSORES_ACTION';
export const LOADED_ASSESSORES_ACTION = 'LOADED_ASSESSORES_ACTION';
export const CLEARED_ASSESSORES_BY_COOP_ACTION =
  'CLEARED_ASSESSORES_BY_COOP_ACTION';
export const LOADING_ASSESSORES_BY_COOP_ACTION =
  'LOADING_ASSESSORES_BY_COOP_ACTION';
export const LOADED_ASSESSORES_BY_COOP_ACTION =
  'LOADED_ASSESSORES_BY_COOP_ACTION';
export const LOADING_ASSESSORES_BY_COOPS_ACTION =
  'LOADING_ASSESSORES_BY_COOPS_ACTION';
export const LOADED_ASSESSORES_BY_COOPS_ACTION =
  'LOADED_ASSESSORES_BY_COOPS_ACTION';
export const CLEARED_ASSESSORES_PAGE_ACTION = 'CLEARED_ASSESSORES_PAGE_ACTION';
export const LOADED_ASSESSORES_PAGE_ACTION = 'LOADED_ASSESSORES_PAGE_ACTION';
export const CLEARED_ASSESSOR_ACTION = 'CLEARED_ASSESSOR_ACTION';
export const CHANGED_ASSESSOR_EDITING_VALUE_ACTION =
  'CHANGED_ASSESSOR_EDITING_VALUE_ACTION';
export const REMOVING_ASSESSOR_ACTION = 'REMOVING_ASSESSOR_ACTION';
export const REMOVED_ASSESSOR_ACTION = 'REMOVED_ASSESSOR_ACTION';
export const SET_ASSESSOR_NAME = 'SET_ASSESSOR_NAME';
export const SET_NAME = 'SET_NAME';
export const CLEAR_NAME_ACTION = 'CLEAR_NAME_ACTION';
export const LOAD_PROGRAMAS_ATIVOS_REQUEST = 'LOAD_PROGRAMAS_ATIVOS_REQUEST';
export const LOAD_PROGRAMAS_ATIVOS_SUCCESS = 'LOAD_PROGRAMAS_ATIVOS_SUCCESS';
export const LOAD_PROGRAMAS_ATIVOS_FAILURE = 'LOAD_PROGRAMAS_ATIVOS_FAILURE';

export const clearNameAction = () => {
  return {
    type: CLEAR_NAME_ACTION,
  };
};

const getEndpoint = () => {
  return getApis().apis.bff + 'v1/assessor';
};

const getEndpointBackOfficeActivePrograms = () => {
  return getApis().apis.bff + 'v1/programa';
};

const getAssessorGestorEndpoint = () => {
  return getApis().apis.bff + 'v1/assessor-gestor';
};

export const setAssessorName = (name) => ({
  type: SET_ASSESSOR_NAME,
  payload: name,
});

export const setName = (nameType, nameValue) => ({
  type: SET_NAME,
  payload: {
    type: nameType,
    value: nameValue,
  },
});

export const resetAssessoresReducer = () => ({
  type: RESETED_ASSESSORES,
  payload: null,
});

export const loadAssessores = (
  todos,
  assessoresNecessarios,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: CLEARED_ASSESSORES_ACTION,
    });
    dispatch({
      type: LOADING_ASSESSORES_ACTION,
      payload: true,
    });
    toRequest(
      'post',
      [
        getEndpoint() + (todos ? '/true' : '/false'),
        assessoresNecessarios || [],
      ],
      todos ? '/todos-assessores' : '/assessores'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ASSESSORES_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ASSESSORES_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ASSESSORES_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearAssessoresByCoop = () => ({
  type: CLEARED_ASSESSORES_BY_COOP_ACTION,
  payload: null,
});

export const loadAssessoresByCoop = (
  coop,
  assessoresNecessarios,
  isAssessorGestor,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_ASSESSORES_BY_COOP_ACTION,
      payload: true,
    });
    toRequest(
      'post',
      [
        (isAssessorGestor ? getAssessorGestorEndpoint() : getEndpoint()) +
        '/cooperativa/' +
        coop,
        assessoresNecessarios || [],
      ],
      'assessores'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ASSESSORES_BY_COOP_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ASSESSORES_BY_COOP_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ASSESSORES_BY_COOP_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAssessoresByCoops = (
  coops,
  isAssessorGestor,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_ASSESSORES_BY_COOPS_ACTION,
      payload: true,
    });
    toRequest(
      'post',
      [
        (isAssessorGestor ? getAssessorGestorEndpoint() : getEndpoint()) +
        '/cooperativas',
        coops || [],
      ],
      'assessores'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ASSESSORES_BY_COOPS_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ASSESSORES_BY_COOPS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ASSESSORES_BY_COOPS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearAssessoresPageList = () => ({
  type: CLEARED_ASSESSORES_PAGE_ACTION,
  payload: null,
});

export const loadAssessoresPaginados = (
  postData,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    const ensureArray = (data) => (Array.isArray(data) ? data : []);
    postData.estados = ensureArray(postData.estados);
    postData.cidades = ensureArray(postData.cidades);
    postData.escolas = ensureArray(postData.escolas);
    postData.formacaoAcademica = ensureArray(postData.formacaoAcademica);
    const url = `${getEndpoint()}/page?page=${postData.page}&size=${postData.size
      }`;
    const { ...bodyData } = postData;
    toRequest('post', [url, bodyData], 'assessoresPaginado').then(
      (resp) => {
        dispatch({
          type: LOADED_ASSESSORES_PAGE_ACTION,
          payload: {
            ...resp.data,
            busca: postData.busca,
            page: postData.page,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const changeAssessorStatus = (
  cpf,
  status,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      'put',
      [`${getEndpoint()}/${cpf}/status/${status}`],
      'save'
    ).then(
      () => {
        dispatch({
          type: CHANGE_ASSESSOR_STATUS_ACTION,
          payload: {
            cpf,
            status,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearAssessorEditing = () => ({
  type: CLEARED_ASSESSOR_ACTION,
  payload: null,
});

export const changeAssessorEditingValue = (name, value) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      if (typeof value === 'string') {
        if (value.trim().length > 0) {
          dispatch({
            type: CHANGED_ASSESSOR_EDITING_VALUE_ACTION,
            payload: { name, value },
          });
        } else {
          dispatch({
            type: CHANGED_ASSESSOR_EDITING_VALUE_ACTION,
            payload: { name, value: '' },
          });
        }
      }
      dispatch({
        type: CHANGED_ASSESSOR_EDITING_VALUE_ACTION,
        payload: { name, value },
      });
      resolve();
    });
  };
};

export const loadProgramasAtivos = () => {
  return (dispatch) => {
    dispatch({ type: LOAD_PROGRAMAS_ATIVOS_REQUEST });
    toRequest('get',
      [`${getEndpointBackOfficeActivePrograms()}/ativos`],
      'assessor'
    )
      .then((response) => {
        dispatch({
          type: LOAD_PROGRAMAS_ATIVOS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        console.log('loadProgramasAtivos falha', error);
        dispatch({
          type: LOAD_PROGRAMAS_ATIVOS_FAILURE,
          payload: error,
        });
      });
  };
};

export const loadAssessorByCPF = (cpf, callbackSuccess, callbackError) => {
  return (dispatch) => {
    toRequest('get', [`${getEndpoint()}/${cpf}`], 'assessor').then(
      (resp) => {
        dispatch({
          type: LOADED_ASSESSOR_ACTION,
          payload: resp.data,
        });
        callbackSuccess(resp.data);
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const saveAssessorByCPF = (assessor, callbackSuccess, callbackError) => {
  return (dispatch) => {
    toRequest('put', [`${getEndpoint()}`, assessor], 'save').then(
      (resp) => {
        dispatch({
          type: SAVED_ASSESSOR_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const deleteAssessorPedagogico = (
  cpf,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: REMOVING_ASSESSOR_ACTION,
      payload: true,
    });
    toRequest('delete', [`${getEndpoint()}/${cpf}`], 'save').then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: REMOVING_ASSESSOR_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};
